import React from 'react';
import styled from 'styled-components';
import { CheckCircle, ExternalLink } from 'react-feather';
import Modal from 'components/_UI/Modal';
import Text from 'components/_UI/Text';
import colors from 'theme/colors';

export default function PaymentSuccessModal({
    isOpen,
    title = 'Compra realizada com sucesso',
    subtitle = 'Seu pagamento está em processamento.',
    onClose,
    onGoToWallet,
}) {
    return (
        <Modal isOpen={isOpen} closeButton={false}>
            <ModalBody>
                <SuccessBadge>
                    <CheckCircle size={28} color={colors.neutralLight} />
                </SuccessBadge>

                <Text
                    name='highlight'
                    type='bold'
                    paddingBottom={0}
                    color={colors.nightDark}
                    textAlign='center'
                    marginTop='16px'
                >
                    {title}
                </Text>

                <Text
                    color={colors.night}
                    textAlign='center'
                    paddingBottom={0}
                    marginTop='8px'
                >
                    {subtitle}
                </Text>

                <InfoCard>
                    <InfoRow>
                        <InfoDot />
                        <Text name='small' color={colors.night} paddingBottom={0}>
                            Você receberá um e-mail em breve com todas as informações sobre o seu pedido.
                        </Text>
                    </InfoRow>
                    <InfoRow>
                        <InfoDot />
                        <Text name='small' color={colors.night} paddingBottom={0}>
                            Detalhes do ingresso/produto adquirido e instruções adicionais estarão no e-mail.
                        </Text>
                    </InfoRow>
                    <InfoRow>
                        <InfoDot />
                        <Text name='small' color={colors.night} paddingBottom={0}>
                            Agradecemos pela sua compra e esperamos que você aproveite ao máximo!
                        </Text>
                    </InfoRow>
                </InfoCard>

                <ButtonGroup>
                    <SecondaryButton onClick={onClose}>
                        Fechar
                    </SecondaryButton>
                    <PrimaryButton onClick={onGoToWallet}>
                        <ExternalLink size={16} color={colors.neutralLight} />
                        Ver carteira
                    </PrimaryButton>
                </ButtonGroup>
            </ModalBody>
        </Modal>
    );
}

const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
`;

const SuccessBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${colors.successDark};
`;

const InfoCard = styled.div`
    width: 100%;
    background: ${colors.night}06;
    border: 1px solid ${colors.night}11;
    border-radius: 10px;
    padding: 14px 16px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InfoRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
`;

const InfoDot = styled.div`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.occasionalPurple};
    flex-shrink: 0;
    margin-top: 6px;
`;

const ButtonGroup = styled.div`
    display: flex;
    width: 100%;
    gap: 10px;
    margin-top: 24px;
`;

const SecondaryButton = styled.button`
    flex: 1;
    padding: 12px;
    border-radius: 10px;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.night}22;
    color: ${colors.night};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
        background: ${colors.neutralDark};
    }
`;

const PrimaryButton = styled.button`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border-radius: 10px;
    background: ${colors.occasionalPurple};
    border: none;
    color: ${colors.neutralLight};
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.15s ease;

    &:hover {
        opacity: 0.9;
    }
`;
